import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface Club {
  id: string;
  name: string;
  description?: string;
  location: string;
  image_url?: string;
  sport: string;
  members_count: number;
  rating: number;
  contact_email?: string;
  contact_phone?: string;
  website?: string;
  created_at: string;
  updated_at: string;
}

export function useClubs() {
  const [clubs, setClubs] = useState<Club[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchClubs = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('clubs')
        .select('*')
        .order('rating', { ascending: false });

      if (error) throw error;
      setClubs(data || []);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClubs();
  }, []);

  const refetch = () => {
    fetchClubs();
  };

  return { clubs, loading, error, refetch };
}

export function useClubsBySport(sport: string) {
  const { clubs, loading, error, refetch } = useClubs();
  
  const filteredClubs = clubs.filter(club => 
    club.sport.toLowerCase() === sport.toLowerCase()
  );
  
  return { clubs: filteredClubs, loading, error, refetch };
}